import fsmMakePick from '../fsm/make_pick';

const submitDisabling = ($submit) => {
  switch (fsmMakePick.state) {
    case 'inProgress':
      $submit.each((e) => {
        $submit.prop('disabled', true);
      });
      break;
    default:
      $submit.prop('disabled', false);
      break;
  }
};

export default submitDisabling;
